import { render, staticRenderFns } from "./AmountWithGrowth.vue?vue&type=template&id=318cb5a4&scoped=true&"
import script from "./AmountWithGrowth.vue?vue&type=script&lang=js&"
export * from "./AmountWithGrowth.vue?vue&type=script&lang=js&"
import style0 from "./AmountWithGrowth.vue?vue&type=style&index=0&id=318cb5a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318cb5a4",
  null
  
)

export default component.exports